import React, { type PropsWithChildren } from 'react';
import { Stack, type StackProps } from '@atlaskit/primitives/compiled';
import { cssMap, cx } from '@atlaskit/css';
import { Header } from './header/index.tsx';

const contentStyles = cssMap({
	modalContent: {
		minHeight: '352px',
	},
});

type OnboardingContentProps = PropsWithChildren & {
	space?: StackProps['space'];
	inModal?: boolean;
};

export const OnboardingContent = ({
	children,
	space = 'space.300',
	inModal = true,
}: OnboardingContentProps): React.JSX.Element => {
	return (
		<Stack space="space.400">
			<Header />
			<Stack xcss={cx(inModal && contentStyles.modalContent)} space={space}>
				{children}
			</Stack>
		</Stack>
	);
};
